<template>
  <div class="page_wrapper container-fluid student_area">
    <div class="row profile_header page_header student_header">
      <enterprises-register-header />
    </div>
    <div class="row student_content">
      <enterprises-register-content />
    </div>
  </div>
</template>
<script>
import EnterprisesRegisterHeader from '~components/pages/enterprises/EnterprisesRegisterHeader'
import EnterprisesRegisterContent from '~components/pages/enterprises/EnterprisesRegisterContent'
export default {
  middleware: ['enterprise-register'],
  name: 'RegisterEnterprise',
  routerName: 'EnterprisesRegister',
  components: {
    EnterprisesRegisterHeader,
    EnterprisesRegisterContent
  }
  // ! 使用者的系統時間可能不正確
  // beforeRouteEnter (to, from, next) {
  //   const time = new Date(to.query.expires_at)
  //   const now = new Date()
  //   if (time - now > 0) {
  //     next()
  //   } else {
  //     next(vm => {
  //       vm.$router.replace({
  //         path: '/login/enterprise'
  //       })
  //       vm.$store.dispatch('layouts/newToast', {
  //         variant: 'warning',
  //         message: '有效時間24小時已過，請至企業專區重新申請註冊'
  //       })
  //     })
  //   }
  // }
}
</script>
